import redirectToLogin from './redirectToLogin';

const AUTH_FAILURE_STATUSES = [401, 403];

/**
 * HTTP status of a failed API call, from an axios error or an ApiResponseError.
 * @param {Error} error
 * @returns {number|undefined} undefined for network errors and timeouts
 */
export const getResponseStatus = error => error?.response?.status ?? error?.status;

/**
 * Message for diagnostics only. Prefers the API's ApiMessage, which may be reworded at any time,
 * so never branch on it.
 * @param {Error} error
 * @returns {string|undefined}
 */
export const getApiErrorMessage = error => error?.response?.data?.ApiMessage ?? error?.message;

export const isAuthFailure = error => AUTH_FAILURE_STATUSES.includes(getResponseStatus(error));

/**
 * Non-2xx response from a fetch call, shaped like an axios error so the same handlers apply.
 */
export class ApiResponseError extends Error {
  constructor(status, body) {
    const data = body ?? {};
    super(data.ApiMessage ?? `Request failed with status code ${status}`);
    this.name = 'ApiResponseError';
    this.status = status;
    this.errorCode = data.ErrorCode;
    this.response = { status, data };
  }
}

/**
 * Sends the student back to login on a 401/403 and stops callAsyncWithRetry, like getToken() does.
 * @param {Error} error
 * @returns {boolean} true when the error was an auth failure
 */
export const handleAuthFailure = (error) => {
  if (!isAuthFailure(error)) {
    return false;
  }
  Object.assign(error, { noAsyncWithRetry: true });
  redirectToLogin();
  return true;
};
